import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, Space, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { Folder } from '../../types/testItem';
import { testItemService } from '../../services/testItemService';

interface FolderFormProps {
    projectId: number;
    initialValues?: Folder | null;
    folders?: Folder[];
    onSubmit: (values: any) => void;
    onCancel: () => void;
}

export const FolderForm: React.FC<FolderFormProps> = ({ projectId, initialValues, folders = [], onSubmit, onCancel }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue({
                name: initialValues.name || '',
                parent_id: initialValues.parent_id || undefined,
                description: initialValues.description || ''
            });
        } else {
            form.resetFields();
        }
    }, [initialValues, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            onSubmit({ ...values, project_id: projectId });
            form.resetFields();
        } catch (error) {
            message.error(t('testItems.errors.required'));
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
        >
            <Form.Item
                name="name"
                label={t('testItems.form.folderName')}
                rules={[{ required: true, message: t('testItems.errors.required') }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name="parent_id"
                label={t('testItems.form.parentFolder')}
            >
                <Select allowClear>
                    {folders?.map(folder => (
                        <Select.Option key={folder.id} value={folder.id}>
                            {folder.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item>
                <Space>
                    <Button type="primary" htmlType="submit">
                        {t('common.save')}
                    </Button>
                    <Button onClick={onCancel}>
                        {t('common.cancel')}
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
}; 